import { Card } from "../../design-v2";
import ExerciseCard from "./ExerciseCard";

export default function SupersetGroup({ block, position, presentationFallbackIntensity = null }) {
  const exercises = Array.isArray(block.exercises) ? block.exercises : [];
  return (
    <Card
      as="section"
      padding="none"
      className="lz-product-superset"
      aria-label={`Superset, ${block.sets} rounds`}
    >
      <header className="lz-product-superset__header">
        {position ? <span className="lz-product-block-index lz-product-block-index--info">{position}</span> : null}
        <h3>Superset</h3>
      </header>
      <div className="lz-product-superset__lanes">
        {exercises.map((exercise) => (
          <ExerciseCard
            key={exercise.id || exercise.label || exercise.exerciseId}
            block={exercise}
            contained
            presentationFallbackIntensity={presentationFallbackIntensity}
          />
        ))}
      </div>
      {block.notes ? <p className="lz-product-block-notes">{block.notes}</p> : null}
      {block.rest ? (
        <p className="lz-product-superset__rest">Rest {block.rest} between rounds</p>
      ) : null}
    </Card>
  );
}
